import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import ServiceBody from "../../ServiceComponents/ServiceBody";

import { FaGreaterThan } from "react-icons/fa6";

import ServiceSection from "../../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../../PageElements/HomePageElements/ConsultSection";
import ImagingMainSection from "../../PageElements/ImagingPageElement/ImagingMainSection";

export default function ImaginePage() {
    return (
        <>
            <ServiceHeader
                childClass="pathologyBGSection"
                breadcrumb={<>Services <FaGreaterThan size={15} /> Radiology</>}
                title="Radiology"
            />
            

           <ImagingMainSection/>
            {/* <ServiceSection /> */}
            {/* <ConsultSection /> */}
        </>
    )
}